import { createReducerFromMap, createAsyncReducer, createDefaultInitialState } from "@coverme/redux";

const initialState = createDefaultInitialState({});

export const householdReducer = createReducerFromMap(initialState, {
    ...createAsyncReducer("GET_HOUSEHOLD"),
});
